import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Image,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import config from "../../config";
import axios from "axios";
import { toast } from "react-toastify";

const Resources = () => {
  const [searchValue, setSearchValue] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState(0);
  const [resourcesEbookData, setResourcesEbookData] = useState([]);

  const [resourcesPracticeData, setResourcesPracticeData] = useState([]);

  const [resourceid, setResourceid] = useState(null);
  const [resourcename, setResourcename] = useState(null);
  const [resources_categoryData, setResources_categoryData] = useState([]);

  // Resource E-Book and Practice
  const [isSubmittingEBook, setIsSubmittingEBook] = useState(false);

  const [isSubmittingPractice, setIsSubmittingPractice] = useState(false);

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhonenumber] = useState("");

  // Show error and loading
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});

  //All Validations
  const validate = () => {
    const newErrors = {};

    if (!firstname) {
      newErrors.firstname = "First Name is required";
    }

    if (!lastname) {
      newErrors.lastname = "Last Name is required";
    }

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email address is invalid";
    }

    if (!phonenumber) {
      newErrors.phonenumber = "Phone Number is required";
    }

    return newErrors;
  };

  // Fetch Resource Detail
  useEffect(() => {
    document.title = `Resources | Agile Seekers`;
    document.getElementById("bodywrap").className = "resomain";

    // Define your API URL
    const ResourcesApiUrl = `${config.API_BASE_URL}/Resources`;

    const fetchResourcesData = async () => {
      try {
        const requestData = {
          resources_category_id: selectedCategoryId,
          search_val: searchValue,
        };

        const response = await axios.post(ResourcesApiUrl, requestData, {
          headers: { "Content-Type": "application/json" },
        });

        if (response.data.status === 1) {
          setResourcesEbookData(response.data.data.ebook);
          setResourcesPracticeData(response.data.data.practice_test);
        } else {
          setError("Failed to load resources content");
        }
      } catch (err) {
        console.error("Error fetching resources:", err);
        setError("An error occurred while fetching resources");
      } finally {
        setLoading(false);
      }
    };

    fetchResourcesData();
  }, [searchValue, selectedCategoryId]);

  const handleCategoryChange = (e) => {
    const { id } = e.target;
    setSelectedCategoryId(Number(id)); // Update the selected category ID
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const clearSelection = () => {
    setSelectedCategoryId("");
    setSearchValue("");
  };

  // Fetch Resource Category Detail
  useEffect(() => {
    const Resources_categoryApiUrl = `${config.API_BASE_URL}/resources_category`;

    // Make the POST request using axios
    axios
      .post(Resources_categoryApiUrl, {})
      .then((response) => {
        if (response.data.status === 1) {
          setResources_categoryData(response.data.data);
        } else {
          setError("Failed to load content");
          console.error("Error:", response.data.message);
        }
        setLoading(false); // Hide loading indicator
      })
      .catch((error) => {
        console.error("Axios Error:", error);
      });
  }, []);

  const [ebookshow, setEBookShow] = useState(false);

  const handleEBookClose = () => {
    setErrors({});
    setEBookShow(false);
  };

  const handleEBookShow = (id, name) => {
    setResourceid(id);
    setResourcename(name);
    setEBookShow(true);
  };

  const [practiceShow, setPracticeShow] = useState(false);

  const handlePracticeClose = () => {
    setErrors({});
    setPracticeShow(false);
  };

  const handlePracticeShow = (id, name) => {
    setResourceid(id);
    setResourcename(name);
    setPracticeShow(true);
  };

  const ebook_submit = async () => {
    const validationErrors = validate();

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmittingEBook(true); // Start the loading state
      let item = {};
      item.resources_id = resourceid;
      item.first_name = firstname;
      item.last_name = lastname;
      item.email = email;
      item.phone_number = phonenumber;
      item.ebook_name = resourcename;
      item.page_url = window.location.href;

      setErrors({});

      try {
        let response = await fetch(
          `${config.API_BASE_URL}/resources_download_ebook`,
          {
            method: "post",
            body: JSON.stringify(item),
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        response = await response.json();

        if (response.status === 1) {
          setEBookShow(false); // Hide the form modal or dialog


          // Zoho Lead API Code Start
          const payload = {
            data: [
              {
                Company: "Agile",
                First_Name: firstname,
                Last_Name: lastname,
                Email: email,
                Phone: phonenumber,
                Lead_Status: "New",
                Lead_Source: "Direct",
                Page_name: window.location.href,
              },
            ],
            trigger: ["approval", "workflow", "blueprint"],
          };

          try {
            const response = await fetch(`${config.API_BASE_URL}/zoho/resources_download_ebook`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (result.status === 1) {
              setErrors({});

              // toast.success(result.message);
            } else {
              // toast.error(result.message);
              console.error("Zoho Error:", result);
            }
          } catch (error) {
            console.error("Fetch error:", error);
          }
          // Zoho Lead API Code End


          setFirstname("");
          setLastname("");
          setEmail("");
          setPhonenumber("");

          setIsSubmittingEBook(false); // End the loading state
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An unexpected error occurred.");
      } finally {
        setIsSubmittingEBook(false); // End the loading state
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const practice_submit = async () => {
    const validationErrors = validate();

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmittingPractice(true); // Start the loading state
      let item = {};
      item.resources_id = resourceid;
      item.first_name = firstname;
      item.last_name = lastname;
      item.email = email;
      item.phone_number = phonenumber;
      item.practice_test_course_name = resourcename;
      item.page_url = window.location.href;

      setErrors({});

      try {
        let response = await fetch(
          `${config.API_BASE_URL}/resources_download_practice_test`,
          {
            method: "post",
            body: JSON.stringify(item),
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        response = await response.json();

        if (response.status === 1) {

          // Zoho Lead API Code Start
          const payload = {
            data: [
              {
                Company: "Agile",
                First_Name: firstname,
                Last_Name: lastname,
                Email: email,
                Phone: phonenumber,
                Lead_Status: "New",
                Lead_Source: "Direct",
                Page_name: window.location.href,
              },
            ],
            trigger: ["approval", "workflow", "blueprint"],
          };

          try {
            const response = await fetch(`${config.API_BASE_URL}/zoho/resources_download_practice_test`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (result.status === 1) {
              setErrors({});

              // toast.success(result.message);
            } else {
              // toast.error(result.message);
              console.error("Zoho Error:", result);
            }
          } catch (error) {
            console.error("Fetch error:", error);
          }
          // Zoho Lead API Code End

          setPracticeShow(false);

          setFirstname("");
          setLastname("");
          setEmail("");
          setPhonenumber("");

          // Display alert with message
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An unexpected error occurred.");
      } finally {
        setIsSubmittingPractice(false); // End the loading state
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <>
      <Navbar />

      <section className="resowrap">
        <Container>
          <Row className="rs-filter">
            <Col md={3} className="rs-box">
              <h3>Resources</h3>
              <Form>
                <Col className="fr-search">
                  <Row>
                    <Col xs="auto" className="pe-0">
                      <Button>
                        <Image
                          src={`${config.BASE_URL}/assets/images/search.png`}
                          className="img-fluid"
                          alt="search"
                        />
                      </Button>
                    </Col>

                    <Col className="ps-0">
                      <Form.Control
                        plaintext
                        placeholder="search"
                        value={searchValue}
                        onChange={handleSearchChange}
                      />
                    </Col>
                  </Row>
                </Col>
              </Form>

              <Col className="frbox">
                <Row>
                  <Col className="frtitle px-0">
                    <Image
                      src={`${config.BASE_URL}/assets/images/filter.png`}
                      className="img-fluid"
                      alt="filter"
                    />
                    <p>Filter Resources</p>
                  </Col>
                </Row>

                <Row>
                  <Col md={12} className="px-0">
                    <div className="cusradio">
                      <Form>
                        {["radio"].map((type) => (
                          <div key={`inline-${type}`} className="mb-3">
                            {loading && (
                              <div key={`inline-${type}`} className="mb-3">
                                Loading...
                              </div>
                            )}
                            {!loading && error && (
                              <div key={`inline-${type}`} className="mb-3">
                                {error}
                              </div>
                            )}
                            {!loading &&
                              !error &&
                              (resources_categoryData.length > 0 ? (
                                resources_categoryData.map((item, index) => (
                                  <Form.Check
                                    label={item.name}
                                    name="group1"
                                    type={type}
                                    id={item.id}
                                    key={index}
                                    checked={selectedCategoryId === item.id}
                                    onChange={handleCategoryChange}
                                  />
                                ))
                              ) : (
                                <div key={`inline-${type}`} className="mb-3">
                                  No data available.
                                </div>
                              ))}
                          </div>
                        ))}
                      </Form>
                      <Button onClick={clearSelection}>Clear</Button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Col>

            {/* E Books */}
            <Col md={9} className="rs-ebook">
              <h3>E Books</h3>
              <Row>
                {loading && (
                  <Col sm={6} md={4} lg={3} className="ebsingle">
                    Loading...
                  </Col>
                )}
                {!loading && error && (
                  <Col sm={6} md={4} lg={3} className="ebsingle">
                    {error}
                  </Col>
                )}
                {!loading &&
                  !error &&
                  (resourcesEbookData.length > 0 ? (
                    resourcesEbookData.map((item, index) => (
                      <Col
                        sm={6}
                        md={4}
                        lg={3}
                        className="ebsingle"
                        id={item.id}
                        key={index}
                      >
                        <Col>
                          <Col>
                            <h6 onClick={() => handleEBookShow(item.id, item.name)}>
                              {item.name}
                            </h6>
                            <p>{item.category_name}</p>
                          </Col>
                          <Link
                            to=""
                            onClick={() => handleEBookShow(item.id, item.name)}
                            id={item.id}
                          >
                            <Image
                              src={`${config.BASE_URL}/assets/images/download.png`}
                              className="img-fluid"
                              alt="download"
                            />
                          </Link>
                        </Col>
                        <Image
                          src={item.image}
                          className="img-fluid"
                          alt="eb1"
                          onClick={() => handleEBookShow(item.id, item.name)}
                        />
                      </Col>
                    ))
                  ) : (
                    <Row className="d-flex align-items-center justify-content-center">
                      <Col sm={6} md={4} lg={3} className="ebsingle">
                        No Resource available.
                      </Col>
                    </Row>
                  ))}
              </Row>
            </Col>
          </Row>

          {/* Our Practice Test Courses */}
          <Row className="res-accordian">
            <Col md={12} className="rs-ebook">
              <h3>Our Practice Test Courses</h3>
              <Row>
                {loading && (
                  <Col sm={6} md={4} lg={3} className="ebsingle">
                    Loading...
                  </Col>
                )}
                {!loading && error && (
                  <Col sm={6} md={4} lg={3} className="ebsingle">
                    {error}
                  </Col>
                )}
                {!loading &&
                  !error &&
                  (resourcesPracticeData.length > 0 ? (
                    resourcesPracticeData.map((item, index) => (
                      <Col
                        sm={6}
                        md={4}
                        lg={3}
                        className="pcebsingle"
                        key={index}
                      >
                        <Col>
                          <Col>
                            <h6 onClick={() => handlePracticeShow(item.id, item.name)}>
                              {item.name}
                            </h6>
                            <p>{item.category_name}</p>
                          </Col>
                          <Link
                            to=""
                            onClick={() => handlePracticeShow(item.id, item.name)}
                          >
                            <Image
                              src={`${config.BASE_URL}/assets/images/download.png`}
                              className="img-fluid"
                              alt="download"
                            />
                          </Link>
                        </Col>
                        <Image
                          src={item.image}
                          className="img-fluid"
                          alt="eb1"
                          onClick={() => handlePracticeShow(item.id, item.name)}
                        />
                      </Col>
                    ))
                  ) : (
                    <Col sm={6} md={4} lg={3} className="ebsingle">
                      No data available.
                    </Col>
                  ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      {/* E-Book Modal */}
      <Modal
        show={ebookshow}
        onHide={handleEBookClose}
        centered
        className="ebook-popup"
        backdrop="static"
      >
        <Modal.Body>
          <Col className="ep-top">
            <h3>Download E-Book</h3>
            <Link onClick={handleEBookClose}>
              <Image
                src={`${config.BASE_URL}/assets/images/close.png`}
                className="img-fluid"
                alt="close"
              />
            </Link>
          </Col>

          <Col>
            <Form>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="fname">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="firstname"
                    placeholder="Enter First Name"
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                  />
                  {/* First Name validation */}
                  {errors.firstname && (
                    <div className="text-danger">{errors.firstname}</div>
                  )}
                </Form.Group>

                <Form.Group as={Col} controlId="lname">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="lastname"
                    placeholder="Enter Last Name"
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                  />
                  {/* Last Name validation */}
                  {errors.lastname && (
                    <div className="text-danger">{errors.lastname}</div>
                  )}
                </Form.Group>
              </Row>

              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />

                {/* email validation */}
                {errors.email && (
                  <div className="text-danger">{errors.email}</div>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="phone">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  name="phonenumber"
                  placeholder="Enter Phone Number"
                  value={phonenumber}
                  onChange={(e) => setPhonenumber(e.target.value)}
                />

                {/* phonenumber validation */}
                {errors.phonenumber && (
                  <div className="text-danger">{errors.phonenumber}</div>
                )}
              </Form.Group>

              {/* Submit Button And Loding Spinners  */}
              <Button
                variant="primary"
                type="button"
                onClick={ebook_submit}
                disabled={isSubmittingEBook}
              >
                {isSubmittingEBook ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="mx-2"
                    />
                    Loading...
                  </>
                ) : (
                  "Submit"
                )}
              </Button>
            </Form>
          </Col>
        </Modal.Body>
      </Modal>

      {/* Practice Modal */}
      <Modal
        show={practiceShow}
        onHide={handlePracticeClose}
        centered
        className="ebook-popup"
        backdrop="static"
      >
        <Modal.Body>
          <Col className="ep-top">
            <h3>Download Practice Test</h3>
            <Link onClick={handlePracticeClose}>
              <Image
                src={`${config.BASE_URL}/assets/images/close.png`}
                className="img-fluid"
                alt="close"
              />
            </Link>
          </Col>

          <Col>
            <Form>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="fname">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter First Name"
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                  />
                  {/* First Name validation */}
                  {errors.firstname && (
                    <div className="text-danger">{errors.firstname}</div>
                  )}
                </Form.Group>

                <Form.Group as={Col} controlId="lname">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Last Name"
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                  />
                  {/* Last Name validation */}
                  {errors.lastname && (
                    <div className="text-danger">{errors.lastname}</div>
                  )}
                </Form.Group>
              </Row>

              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />

                {/* email validation */}
                {errors.email && (
                  <div className="text-danger">{errors.email}</div>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="phone">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Phone Number"
                  value={phonenumber}
                  onChange={(e) => setPhonenumber(e.target.value)}
                />

                {/* phonenumber validation */}
                {errors.phonenumber && (
                  <div className="text-danger">{errors.phonenumber}</div>
                )}
              </Form.Group>

              {/* Submit Button And Loding Spinners  */}
              <Button
                variant="primary"
                type="button"
                onClick={practice_submit}
                disabled={isSubmittingPractice}
              >
                {isSubmittingPractice ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="mx-2"
                    />
                    Loading...
                  </>
                ) : (
                  "Submit"
                )}
              </Button>
            </Form>
          </Col>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};
export default Resources;
